<template>
  <pre>{{ JSON.stringify(versionInfo, null, 2) }}</pre>
</template>

<script>
export default {
  name: 'Version',
  data () {
    return {
      // eslint-disable-next-line no-undef
      versionInfo: VERSION_INFO // injected by webpack definePlugin
    }
  },

  created () {
    const robotsMeta = document.createElement('meta')
    robotsMeta.name = 'robots'
    robotsMeta.content = 'noindex, nofollow'
    document.head.appendChild(robotsMeta)
  }
}
</script>
